import { PaymentMethodType } from './enums';

export interface PaymentMethodMetadata {
    ignoreForm?: boolean;
    overrideIconFillColor?: boolean;
    allowsSplitPaymentsWithVirtualIncentives: boolean;
    allowsChangingVirtualIncentivesWhenSelected: boolean;
    isAvailableInTablessEnvironment: boolean;
}

const UNTYPED_PAYMENT_METHODS_METADATA = {
    [PaymentMethodType.CREDIT]: {
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: true,
        allowsChangingVirtualIncentivesWhenSelected: true,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.IDEAL]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: false,
    },
    [PaymentMethodType.MAESTRO_BANCONTACT]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: false,
    },
    [PaymentMethodType.SOFORT]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: false,
    },
    [PaymentMethodType.NONCE_BRAINTREE]: {
        allowsSplitPaymentsWithVirtualIncentives: true,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.SEPA_DIRECT_DEBIT]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.CASH]: {
        ignoreForm: true,
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.INVOICE]: {
        ignoreForm: true,
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.CHECK]: {
        ignoreForm: true,
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.FPP_PAYPAL]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.BOLETO_BANCARIO]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.BARCODE]: {
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.RAPIPAGO]: {
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.PAGOFACIL]: {
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.OXXO]: {
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.AUTHNET]: {
        overrideIconFillColor: true,
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.APPLE_PAY]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: true,
    },
    [PaymentMethodType.GOOGLE_PAY]: {
        allowsSplitPaymentsWithVirtualIncentives: false,
        allowsChangingVirtualIncentivesWhenSelected: false,
        isAvailableInTablessEnvironment: false,
    },
};

export const PAYMENT_METHODS_METADATA =
    UNTYPED_PAYMENT_METHODS_METADATA as Record<
        keyof typeof UNTYPED_PAYMENT_METHODS_METADATA,
        PaymentMethodMetadata
    >;
